module.exports = __webpack_public_path__ + "media/CN_011.5720371b.mp3";